import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Accordion, Card, Button } from 'react-bootstrap';
import { actionCreators } from '../actions/globalAction';
import { evubill } from '../components/objects/evuBill';


class EvubillClass extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { currentItemId: [0], EvubillUI:[] };
        this.showMore = this.showMore.bind(this);
    }

    toggle(id) {
        const currentItemId = [...this.state.currentItemId];

        const idx = currentItemId.indexOf(id);
        if (idx >= 0)
            currentItemId.splice(idx, 1);
        else
            currentItemId.push(id);

        this.setState({ currentItemId });
    }

    showMore() {
        let EvubillUI = this.props.EvubillUI;
        let Year = new Date().getFullYear();
        for (let i = 0; i < EvubillUI.length; i++) {
            if (EvubillUI[i].Year < Year)
                Year = EvubillUI[i].Year;
        }

        Year = Year - 1;

        this.setState({ EvubillUI });

        evubill.EvuBillClass.url = evubill.EvuBillClass.defaultSegment + "/evu/" + Year;
        evubill.EvuBillClass.forceRefresh = true;
        this.props.request(evubill["EvuBillClass"]);
    }

    componentDidMount() {
        const Year = parseInt(this.props.match.params.Year) || 0;

        if (Year > 0) {
            evubill.EvuBillClass.url = evubill.EvuBillClass.defaultSegment + "/evu/" + Year;
            evubill.EvuBillClass.forceRefresh = true;
        }
        else {
            evubill.EvuBillClass.url = evubill.EvuBillClass.defaultSegment + "/evu/" + new Date().getFullYear();
        }

        // This method runs when the component is first added to the page
        for (var k in evubill) {
            this.props.request(evubill[k]);
        }
    }


    render() {
        let EvubillUI = this.props.EvubillUI || {}
        let EvubillUIState = this.state.EvubillUI || {};

        let dataEvu = [];

        if (typeof (EvubillUI) !== 'undefined' && EvubillUI.length > 0) {
            if (typeof (EvubillUIState) !== 'undefined' && EvubillUIState.length > 0) {
                let count = EvubillUIState.length;

                for (let i = 0; i < count; i++) {
                    let currYear = EvubillUIState[i].Year;
                    let dontaddit = false;

                    for (let a = 0; a < EvubillUI.length; a++) {
                        let thisYear = EvubillUI[a].Year;

                        if (currYear == thisYear)
                            dontaddit = true;
                    }
                    if (!dontaddit)
                        EvubillUI.push(EvubillUIState[i]);
                }
            }

            for (let a = 0; a < EvubillUI.length; a++) {
                let evudata = EvubillUI[a];
                let data = [];

                for (let i = 0; i < evudata.SubHeadline.length; i++) {
                    let dataTemp = {
                        SubHeadline: evudata.SubHeadline[i],
                        PanelContent: evudata.PanelContent[i]
                    };

                    data.push(dataTemp);
                }

                let EvubillUI2 = {
                    MegaHeadline: evudata.MegaHeadline,
                    subdata: data
                };

                dataEvu.push(EvubillUI2);
            }
        }

        return (
            <div>
                {
                    dataEvu.reverse().map((_evudata, row) =>
                        <div>
                            <div dangerouslySetInnerHTML={{ __html: _evudata.MegaHeadline }} />
                            {
                                _evudata.subdata.reverse().map((_data, index) =>
                                    <div>
                                        <Button variant="info" onClick={() => this.toggle(index)} style={{ width: '100%', textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: _data.SubHeadline }}></Button>
                                        <Accordion.Collapse in={this.state.currentItemId.includes(index)}>
                                            <Card className="mb-0">
                                                <Card.Body>
                                                    <div dangerouslySetInnerHTML={{ __html: _data.PanelContent }} />
                                                </Card.Body>
                                            </Card>
                                        </Accordion.Collapse>
                                    </div>)
                            }
                        </div>
                    )}
                <p>
                    <Button className="btn btn-primary" style={{ width: '100%' }} onClick={() => this.showMore()} >Show more</Button>.
                </p>
            </div>
        );
    }
}


export default connect(
    state => state.evubillReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(EvubillClass);